import { DownloadOutlined, FilePdfOutlined, FileWordOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Select, Space, Table, Tooltip, Typography } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ContentHeader } from '../../components';
import { searchLength, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from '../../helpers/common';
import { ChiTietHopDongDienTuResponse } from '../../models/hopdong/HopDong';
import { TimKiemNhanVienHopDongRequest } from '../../models/nhanvien/NhanVien';
import { timKiemDSHopDongDienTu } from '../../services/hopdong';
import TrangThaiHopDongDienTuTag, { dsTrangThaiHopDongDienTu } from './TrangThaiHopDongDienTuTag';
import LoaiHopDongTree from '@app/modules/danhmuc/LoaiHopDongTree';

const { Text } = Typography;

const DanhSachHopDongDienTu = () => {
    const menu: any = menuHelper.checkMultiPermission([Links.HopDong.ChiTiet]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);
    const [tuKhoa, setTuKhoa] = useState<string>('');
    const [idLoaiHopDong, setIdLoaiHopDong] = useState<number>(0);
    /// API chưa lọc theo trạng thái nên lọc lại phía client trên danh sách đã lấy về
    const [trangThai, setTrangThai] = useState<number | null>(null);
    const [danhSach, setDanhSach] = useState<Array<ChiTietHopDongDienTuResponse>>([]);

    /// Truyền length = 0 để lấy toàn bộ danh sách, phân trang do bảng tự xử lý
    const timKiem = async (idLoaiHopDong: number, tuKhoa: string) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            var rq = new TimKiemNhanVienHopDongRequest;
            rq.idDonVi = 0;
            rq.idLoaiHopDong = idLoaiHopDong;
            rq.tuKhoa = tuKhoa;
            const temp = await timKiemDSHopDongDienTu(rq, 0, 0);
            setDanhSach(temp?.data || []);
        }
        catch (error: any) {
            setDanhSach([]);
        };

        setIsLoadingTable(false);
    };

    const onChangeLoaiHopDong = (e: any) => {
        const id = e?.id || 0;
        setIdLoaiHopDong(id);
        timKiem(id, tuKhoa);
    };

    const containerLoaiHopDongProps = {
        showHeader: false,
        onChange: onChangeLoaiHopDong,
    };

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timKiem(idLoaiHopDong, tuKhoa);
        }
    };

    useEffect(() => {
        timKiem(idLoaiHopDong, tuKhoa);
    }, []);

    const chuaCo = (noiDung: string) => <Text type="secondary">{noiDung}</Text>;

    /// Chỉ tệp PDF mới mở thẳng trên trình duyệt được, tệp Word phải tải về máy để mở
    const renderTep = (record: ChiTietHopDongDienTuResponse) => {
        if (!record.tenTep) {
            return chuaCo('Chưa có tệp');
        }

        const urlTep = urlAdmin + (record.duongDan || '').replace(/\\/g, '/');
        const laPdf = record.tenTep.toLowerCase().endsWith('.pdf');

        return (
            <Tooltip title={record.tenTep}>
                <a href={urlTep}
                    target={laPdf ? '_blank' : undefined}
                    rel="noreferrer"
                    download={laPdf ? undefined : record.tenTep}>
                    <Space size={4}>
                        {laPdf ? <FilePdfOutlined style={{ color: '#d4380d' }} /> : <FileWordOutlined style={{ color: '#1d39c4' }} />}
                        {laPdf ? 'Xem tệp' : 'Tải tệp'}
                        {!laPdf && <DownloadOutlined />}
                    </Space>
                </a>
            </Tooltip>
        );
    };

    const duLieuHienThi = (danhSach || [])
        .filter((item) => trangThai === null || item.trangThai === trangThai)
        .map((item) => ({ key: item.id, ...item }));

    return (
        <section>
            <ContentHeader title="Quản lý hợp đồng điện tử" />
            <Row className="form-group" gutter={8}>
                <Col span={8}>
                    <Input prefix={<SearchOutlined />}
                        placeholder="Nhập tên nhân viên, email, số hợp đồng, loại hợp đồng"
                        value={tuKhoa}
                        onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={5}>
                    <Select style={{ width: '100%' }}
                        allowClear
                        placeholder="Tất cả trạng thái"
                        value={trangThai}
                        options={dsTrangThaiHopDongDienTu}
                        onChange={(value) => {
                            setTrangThai(value === undefined ? null : value);
                            setPage(1);
                        }} />
                </Col>
                <Col span={11}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined />} onClick={() => timKiem(idLoaiHopDong, tuKhoa)}>
                            Tìm kiếm
                        </Button>
                        {menu[Links.HopDong.ChiTiet] &&
                            <Link className="hrm-btn hrm-btn-warning" to={Links.HopDong.ChiTietHopDongDienTu}>
                                <PlusOutlined /> Thêm mới
                            </Link>
                        }
                    </Space>
                </Col>
            </Row>
            <Row gutter={8}>
                <Col span="6">
                    <LoaiHopDongTree {...containerLoaiHopDongProps} />
                </Col>
                <Col span="18">
                    <div className="card card-primary">
                        <Row>
                            <Col span={24}>
                                <Table
                                    loading={isLoadingTable}
                                    locale={{ emptyText: 'Không có dữ liệu' }}
                                    dataSource={duLieuHienThi}
                                    scroll={{ x: 1100 }}
                                    pagination={{
                                        current: page,
                                        pageSize: searchLength,
                                        showTotal: (total) => `Tổng số ${total} hợp đồng điện tử`,
                                        onChange: (page) => {
                                            setPage(page);
                                        },
                                    }}
                                >
                                    <Column
                                        title="STT"
                                        key="stt"
                                        width={60}
                                        render={(value, record, index) => (
                                            <span key={'stt' + index}>
                                                {(page - 1) * searchLength + index + 1}
                                            </span>
                                        )}
                                    />
                                    <Column
                                        title="Nhân viên"
                                        key="hoTen"
                                        render={(value: ChiTietHopDongDienTuResponse) => (
                                            <>
                                                <div>{value.hoTen}</div>
                                            </>
                                        )}
                                    />
                                    <Column
                                        title="Số hợp đồng"
                                        key="soHopDong"
                                        render={(value: ChiTietHopDongDienTuResponse) => value.soHopDong || chuaCo('Chưa cấp số')}
                                    />
                                    <Column
                                        title="Loại hợp đồng"
                                        key="tenLoaiHopDong"
                                        render={(value: ChiTietHopDongDienTuResponse) => value.tenLoaiHopDong || chuaCo('Không có dữ liệu')}
                                    />
                                    <Column
                                        title="Chức vụ"
                                        key="tenChucVu"
                                        render={(value: ChiTietHopDongDienTuResponse) => value.tenChucVu || chuaCo('Không có dữ liệu')}
                                    />
                                    <Column
                                        title="Ngày bắt đầu"
                                        key="ngayBatDau"
                                        render={(value: ChiTietHopDongDienTuResponse) => dateCommon.formatDate(value.ngayBatDau)}
                                    />
                                    <Column
                                        title="Ngày kết thúc"
                                        key="ngayKetThuc"
                                        render={(value: ChiTietHopDongDienTuResponse) => value.ngayKetThuc ? dateCommon.formatDate(value.ngayKetThuc) : chuaCo('Không xác định')}
                                    />
                                    <Column
                                        title="Ngày ký"
                                        key="ngayKy"
                                        render={(value: ChiTietHopDongDienTuResponse) => value.ngayKy ? dateCommon.formatDate(value.ngayKy) : chuaCo('Chưa ký')}
                                    />
                                    <Column
                                        title="Tệp hợp đồng"
                                        key="tenTep"
                                        render={(value: ChiTietHopDongDienTuResponse) => renderTep(value)}
                                    />
                                    <Column
                                        title="Trạng thái"
                                        key="trangThai"
                                        render={(value: ChiTietHopDongDienTuResponse) => <TrangThaiHopDongDienTuTag value={value.trangThai} />}
                                    />
                                    <Column
                                        title=""
                                        key="action"
                                        width={80}
                                        fixed="right"
                                        render={(value: ChiTietHopDongDienTuResponse) => (
                                            <Link to={Links.HopDong.ChiTietHopDongDienTu + '?id=' + value.id}
                                                className="hrm-btn hrm-btn-sm float-right btn-primary"
                                                title="Chi tiết">
                                                Xem
                                            </Link>
                                        )}
                                    />
                                </Table>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
        </section>
    );
};

export default DanhSachHopDongDienTu;
